import React, { StrictMode, useEffect } from 'react';
import Base from '@/components/edifice/Base/Base';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';

if (process.env.INSTANCE === 'dev' || process.env.INSTANCE === 'test') {
    loadDevMessages();
    loadErrorMessages();
}

const App = () => {
    useEffect(() => {
        const isPrerendering = window.__PRERENDER_INJECTED__?.prerender;

        if (!isPrerendering) {
            document.body.classList.add('mounted', 'loaded');
        }

        return () => {
            if (!isPrerendering) {
                document.body.classList.remove('mounted', 'loaded');
            }
        };
    }, []);
    return (
        <StrictMode>
            <Base />
        </StrictMode>
    );
};

export default App;
